import React from "react";
import styled from "styled-components";
import { Button } from "antd";

const StyledWrapper = styled(Button)`
  background-color: ${(props) => props.bgColor};
  min-width: 120px;
  color: ${(props) => props.color};
  text-align: center;
  height: ${(props) => props.height};
  border: ${(props) => (props.border ? `2px solid #162056` : "none")};
  border-radius: 8px;
  font-size: ${(props) => (props.fontSize ? props.fontSize : null)};
  .ant-btn:hover {
    background-color: ${(props) => props.bgColor};
    color: ${(props) => props.color};
  }
  .ant-btn:focus {
    background-color: ${(props) => props.bgColor};
    color: ${(props) => props.color};
  }
`;
const ButtonWrapper = (props) => {
  return <StyledWrapper {...props}>{props.text}</StyledWrapper>;
};

export default ButtonWrapper;
